module.exports = __webpack_public_path__ + "img/template_4.c6ebd265.png";